<template>
  <div>
    <v-row class="mx-12">
      <template>
        <v-col
          v-for="(attachment, index) in attachments"
          :key="index"
          cols="4"
        >
          <bankruptcy-card
            :info-item="attachment"
            :icon="'mdi-file-document'"
            :header="attachment.categoryName"
            :status=" attachment.name"
            :status-display-name="local.caseFile.cards.document.typeDisplayName"
            :date="attachment.creationDate"
            :date-display-name="local.caseFile.cards.document.dateDisplayName"
            :has-actions="true"
            :court-name="attachment.courtName"
            :sub-circle-name="attachment.subCircleName"
            @card-click="viewAttachment(attachment)"
          >
          </bankruptcy-card>
        </v-col>
      </template>
      <v-col cols="12">
        <naj-no-data
          :has-data="attachments && attachments.length > 0"
          :loading="loading"
        ></naj-no-data>
      </v-col>
    </v-row>

    <show-documents-model
      :documents="attachments"
      :selected-index-prop="selectedDocumentIndex"
      :modal-visibility="showDocumentsInfoModal"
      @modalClose="closeDocumentsInfo"
    ></show-documents-model>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import BankruptcyCard from '../bankruptcy-card.vue';
import ShowDocumentsModel from './show-document-model.vue';

export default {
  name: 'AttachmentsTab',
  components: {
    BankruptcyCard,
    ShowDocumentsModel,
  },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      selectedDocumentIndex: 0,
      showDocumentsInfoModal: false,
      attachments: [],
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getBankruptcyRequestAttachments']),
    loadData() {
      this.loading = true;
      this.getBankruptcyRequestAttachments(this.requestObjectKey)
        .then((res) => {
          this.attachments = res.data;
        })
        .finally(() => {
          this.loading = false;
        });

    },
    viewAttachment(attachment) {
      this.showDocumentsInfoModal = true;
      this.selectedDocumentIndex = this.attachments.findIndex(a => a.objectKey == attachment.objectKey);
    },

    closeDocumentsInfo() {
      this.showDocumentsInfoModal = false;
      this.selectedDocumentIndex = 0;
    },

  },
};

</script>

<style lang="scss" scoped>
</style>
